// src/services/apiService.js
class ApiService {
  constructor() {
    // this.baseURL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
    this.baseURL =
      process.env.REACT_APP_API_URL || "https://demo.shealth.ai/insurance-api/api";
    this.token = localStorage.getItem("auth_token");
  }
  setUser(user) {
    this.user = user;
    try {
      localStorage.setItem("health_user", JSON.stringify(user));
    } catch (e) {
      console.warn("Could not persist user to localStorage", e);
    }
  }
  removeUser() {
    this.user = null;
    localStorage.removeItem("health_user");
  }

  setAuthToken(token) {
    this.token = token;
    localStorage.setItem("auth_token", token);
  }

  removeAuthToken() {
    this.token = null;
    localStorage.removeItem("auth_token");
  }

  async makeRequest(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...(this.token && { Authorization: `Bearer ${this.token}` }),
        ...options.headers,
      },
      ...options,
    };

    try {
      console.log("API Request:", url, config); // Debug log
      const response = await fetch(url, config);

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`
        );
      }

      return await response.json();
    } catch (error) {
      console.error("API request failed:", error);
      throw error;
    }
  }

  // Auth endpoints
  async login(credentials) {
    const response = await this.makeRequest("/auth/login", {
      method: "POST",
      body: JSON.stringify(credentials),
    });
    console.log(response);
    if (response.token) {
      this.setAuthToken(response.token);
    }

    return response;
  }

  async register(userData) {
    const response = await this.makeRequest("/auth/register", {
      method: "POST",
      body: JSON.stringify(userData),
    });

    if (response.token) {
      this.setAuthToken(response.token);
    }

    return response;
  }

  async logout() {
    try {
      await this.makeRequest("/auth/logout", {
        method: "POST",
      });
    } finally {
      this.removeAuthToken();
    }
  }

  async getMe() {
    return this.makeRequest("/auth/me");
  }

  // Dashboard endpoints
  async getDashboardStats(role) {
    const endpoint =
      role === "admin" ? "/dashboard/admin-stats" : "/dashboard/member-stats";
    return this.makeRequest(endpoint);
  }

  // Policy endpoints
  async getPolicies() {
    return this.makeRequest("/policies");
  }

  async createPolicy(policyData) {
    return this.makeRequest("/policies", {
      method: "POST",
      body: JSON.stringify(policyData),
    });
  }

  async updatePolicy(id, policyData) {
    return this.makeRequest(`/policies/${id}`, {
      method: "PUT",
      body: JSON.stringify(policyData),
    });
  }

  async deletePolicy(id) {
    return this.makeRequest(`/policies/${id}`, {
      method: "DELETE",
    });
  }

    async assignPoliciesToMember(memberId, policyIds) {

      console.log("pp",policyIds);
    return this.makeRequest(`/members/${memberId}/assign-policy`, {
      method: "POST",
      body: JSON.stringify({ policy_id: policyIds,
        start_date: new Date().toISOString().split('T')[0], // Current date in YYYY-MM-DD format
        end_date: new Date(new Date().setFullYear(new Date().getFullYear() + 1))
          .toISOString()
          .split('T')[0], // One year from now in YYYY-MM-DD format
       }),
    });
  }





  // Member endpoints
  async getMembers() {
    return this.makeRequest("/members");
  }

    async getMemberById(id) {
    return this.makeRequest(`/members/${id}`);
  }

  async getMyMemership(){
    return this.makeRequest("/members/me");
  }


  async createMember(memberData) {
    return this.makeRequest("/members", {
      method: "POST",
      body: JSON.stringify(memberData),
    });
  }

  async updateMember(id, memberData) {
    return this.makeRequest(`/members/${id}`, {
      method: "PUT",
      body: JSON.stringify(memberData),
    });
  }

  async deleteMember(id) {
    return this.makeRequest(`/members/${id}`, {
      method: "DELETE",
    });
  }

  // Claims endpoints
  async getClaims(filters = {}) {
    const queryString = new URLSearchParams(filters).toString();
    return this.makeRequest(`/claims${queryString ? `?${queryString}` : ""}`);
  }

    // Claims endpoints
  async getClaimById(id) {
    
    return this.makeRequest(`/claims/${id}/get`);
  }



  async submitClaim(claimData) {
    // For file uploads, we need to use FormData
    const formData = new FormData();

    Object.keys(claimData).forEach((key) => {
      if (key === "documents" && claimData[key]) {
        Array.from(claimData[key]).forEach((file, index) => {
          formData.append(`documents[${index}]`, file);
        });
      } else if (claimData[key] !== null && claimData[key] !== undefined) {
        formData.append(key, claimData[key]);
      }
    });

    return this.makeRequest("/claims", {
      method: "POST",
      body: formData,
      headers: {
        // Remove Content-Type to let browser set it with boundary for FormData
        Accept: "application/json",
        ...(this.token && { Authorization: `Bearer ${this.token}` }),
      },
    });
  }

  async reviewClaim(id, reviewData) {
    return this.makeRequest(`/claims/${id}/review`, {
      method: "PUT",
      body: JSON.stringify(reviewData),
    });
  }

  async getClaimDetails(id) {
    return this.makeRequest(`/claims/${id}`);
  }

  // Payment endpoints
  async getPayments() {
    return this.makeRequest("/payments");
  }

  async processPayment(paymentData) {
    return this.makeRequest("/payments", {
      method: "POST",
      body: JSON.stringify(paymentData),
    });
  }

  async updatePaymentStatus(id, statusData) {
    return this.makeRequest(`/payments/${id}/status`, {
      method: "PUT",
      body: JSON.stringify(statusData),
    });
  }

  async getPaymentStats() {
    return this.makeRequest("/payments-stats");
  }

  // Fraud endpoints
  async getFraudCases() {
    return this.makeRequest("/fraud-cases");
  }

  async createFraudCase(caseData) {
    return this.makeRequest("/fraud-cases", {
      method: "POST",
      body: JSON.stringify(caseData),
    });
  }

  async updateFraudCase(id, caseData) {
    return this.makeRequest(`/fraud-cases/${id}/status`, {
      method: "PUT",
      body: JSON.stringify(caseData),
    });
  }

  async getFraudStats() {
    return this.makeRequest("/fraud-stats");
  }

  // Notification endpoints
  async getNotifications() {
    return this.makeRequest("/notifications");
  }

  async markNotificationRead(id) {
    return this.makeRequest(`/notifications/${id}/read`, {
      method: "PUT",
    });
  }

  async getUnreadCount() {
    return this.makeRequest("/notifications/unread-count");
  }
}

export default new ApiService();
